import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';

import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { togglePinnedFiltersState, selectTiresPinnedFilters } from '@store';
import { useHasFilters } from 'hooks/common';
import { useTiresEnums } from './useTiresEnums';

export const useTiresFilterConfig = () => {
  const router = useRouter();
  const dispatch = useDispatch();
  const pinnedFilters = useSelector(selectTiresPinnedFilters);
  const { filterConfig: tiresFilterConfig } = useTiresEnums();

  const filterCategories = useMemo(() => {
    return (tiresFilterConfig?.filterCategories || []).map((category) => ({
      id: category.id,
      label: category.label,
      icon: RadioButtonUncheckedIcon,
      options: category.options,
      multiSelect: category.multiSelect,
    }));
  }, [tiresFilterConfig?.filterCategories]);

  const parseQueryValue = (value, isMultiSelect) => {
    if (value === undefined || value === null) {
      return isMultiSelect ? [] : '';
    }

    if (typeof value === 'string') {
      return isMultiSelect ? value.split(',') : value;
    }

    if (isMultiSelect) {
      return Array.isArray(value) ? value : [];
    }

    return value;
  };

  const currentFilters = useMemo(() => {
    const filters = {};
    (tiresFilterConfig?.filterCategories || []).forEach((category) => {
      filters[category.id] = parseQueryValue(
        router.query[category.id],
        category.multiSelect
      );
    });
    return filters;
  }, [tiresFilterConfig?.filterCategories, router.query]);

  const { hasFilters } = useHasFilters({
    pinnedFilters,
  });

  const handlePinnedFilterSelect = (pinnedFilter) => {
    dispatch(
      togglePinnedFiltersState({
        board: 'tires',
        pinnedFilter,
      })
    );
  };

  return {
    filterCategories,
    currentFilters,
    handlePinnedFilterSelect,
    pinnedFilters,
    supportPinnedFilters: true,
    hasFilters,
  };
};
